export const API_BASE_URL = 'https://api.edzard.com/return/api'
export const ACCESS_TOKEN = 'accessToken'

export const EMAIL_MAX_LENGTH = 6
export const PASSWORD_MIN_LENGTH = 6
export const PASSWORD_MAX_LENGTH = 20